require("./bootstrap");

require("../../../vendor/wire-elements/pro/resources/js/overlay-component.js");

console.log("app-no-vue.js loaded");
import { RadarChart } from "./charts/radar-chart/radar-chart.js";
window.RadarChart = RadarChart;

document.addEventListener("alpine:init", () => {
  Alpine.directive("radar-chart", async (el, { expression }, { evaluate }) => {
    if (!window.d3) {
      await import(/* webpackChunkName: "js/d3" */ "./d3.js");
    }
    evaluate(expression);
  });
});

import Rollbar from "rollbar";

window.showContactModal = function () {
  window.dispatchEvent(new CustomEvent("open-contact-form-modal"));
};
